export default (theme) => {
  return {
    link: {
      fontWeight: 'normal !important',
      color: '#616161 !important',
    },
  }
}
